/* eslint-disable */
/**
 * Created by coolguy on 2017/4/18.
 */
export  default {
    username:(str)=>{
        return /^[\w\d]+$/.test(str);
    },
    password:(str)=>{
        //1~20位
        return /^.{6,20}$/.test(str);
    },
    //手机号码校验
    mobile(text){
        return /^1\d{10}$/.test(text);
    },
    // 身份证校验
    identity(text){
        let weightFactor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //加权因子
        let verifyCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']; //校验码
        let sum = 0;
        let mod = 0;

        if (!(/^\s*[0-9]{17}[0-9X]\s*$/).test(text)) {
            return false;
        }

        for (let i=0; i<17; ++i) {
            sum += text[i] * weightFactor[i];
        }
        mod = sum % 11;

        return (text[17] === verifyCode[mod]);
    },
    //QQ号码校验
    QCheck(text){
        return /^[1-9]\d{4,10}$/.test(text);
    },
    //电话号码校验
    //根据产品需求，电话只需要校验允许输入数字-*即可
    teleCheck(text){
        return /^[\d\-\*]+$/.test(text);
        //return /^[0]{1}[0-9]{2,3}[0-9]{3,8}$/.test(text);
        //return /^[0-9]{1,3}[-]?[0-9]{3,8}[*]?[0-9]{3,5}$/.test(text);
    },
    //联系电话
    phoneCheck(text){
        return /^0{0,1}(13[^4]|15[^4]|14[57]|17[0-9]|18[0-9])[0-9]{8}$|134[0-8][0-9]{7}$/.test(text);
    },
    //特殊字符
    codeCheck(text){
        return /[`~!@#\$%\^\&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]]/im.test(text);
    },
    //只允许中文，数字，英文和空格
    normal(text, useReplace) {
        if(useReplace) {
            return text.replace(/[^\u4E00-\u9FA5\uF900-\uFA2Da-z0-9A-Z ]/g, '');
        }else {
            return /^[\u4E00-\u9FA5\uF900-\uFA2Da-z0-9A-Z ]+$/.test(text);
        }
    },
    emojiCheck(text) {
        return /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g.test(text);
    },
    // email
    emailCheck(text){
        return /^([a-zA-Z0-9]+[_|\_|\.|-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(text);
    },
    userCheck(text){  //英文数字
        return /^[a-z0-9A-Z]+$/.test(text);
    },
    nameCheck(text){
        return /^[\u4E00-\u9FA5\uF900-\uFA2Da-z0-9A-Z]+$/.test(text);
    },
    //检测是否是空对象{},注意:返回值:true:表示是空对象;false:表示不是空对象--wwt
    isEmptyObject(obj){
        for(var key in obj){
            return false;
        }
        return true
    },
    imgUrlCheck(text){
        if(text&&text.indexOf('http://') == -1){
            return true;
        }
        return false;
    },
    //允许最多2位小数的数字（最长小数点前的数字不超过10位
    moneyCheck(text){
        return /^(([1-9]\d{0,10})|0)(\.\d{0,2})?$/.test(text);
    }
}



// WEBPACK FOOTER //
// ./src/util/CheckList.js